import Analyses from '../../Analyses'
import { IDiagnosticImageReport } from '../../../types/diagnostic-image'
import { Text, View } from '@react-pdf/renderer'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const AiReportBox = ({
  diagnosticImages,
}: {
  diagnosticImages: IDiagnosticImageReport[] | undefined
}) => {
  const { t } = useTranslation()

  return (
    <View break>
      <Text
        style={[
          styles.subtitle,
          styles.boldText,
          styles.underlineText,
          styles.mediumMb,
        ]}
      >
        {t('ai.reportTitle')}
      </Text>
      <Text style={[styles.extraSmallTextItalic]}>
        {t('ai.reportPreventMsg')}
      </Text>

      <Analyses diagnosticImages={diagnosticImages ?? []} isToPrint />
    </View>
  )
}

export default AiReportBox
